export default "__VITE_ASSET__CnqHMepA__"